import React, { useState, useEffect, useContext } from 'react';
import { AuthUserContext, withAuthorization } from '../Session';
import AdminLayout from './AdminLayout';
import { ApiHelpers } from '../../helpers';
import { Form, Tabs, Skeleton } from 'antd';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { useCompany } from '../../swr';
import { useRecoilState } from 'recoil';
import { activeRestaurantState } from '../../recoil';
import RestaurantOffers from './Restaurant/RestaurantOffers';
import Onboarding from './Onboarding';

const { TabPane } = Tabs;

function RestaurantOffersHome(props) {
    // Get AuthUser ID from Firebase
    const firebaseAuthUser = useContext(AuthUserContext);
    let { restaurantId } = useParams();
    const [restaurantDetails, setRestaurantDetails] = useState([]);
    const [entryFound, setEntryFound] = useState(false);
    const [activeTabKey, setActiveTabKey] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [activeRestaurant, setActiveRestaurant] = useRecoilState(activeRestaurantState);

    const { data: companyDetails, isLoading: isLoadingCompanyDetails } = useCompany('getDetails', firebaseAuthUser.uid);
    let companyIdentificationToken = null;

    if (companyDetails) {
        companyIdentificationToken = companyDetails.uniqueIdentificationToken;
    }
    const routeLocation = useLocation();
    useEffect(() => {
        // Get Restaurant by Id
        setIsLoading(true);
        ApiHelpers.getRestaurantsByCode(restaurantId).then(
            (response) => {
                if (response.data.message) {
                    setEntryFound(false);
                } else {
                    setRestaurantDetails({
                        ...response.data,
                        companyIdentificationToken: companyIdentificationToken,
                    });
                    setEntryFound(true);
                }
                setIsLoading(false);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [restaurantId]);

    useEffect(() => {
        if (routeLocation.hash) {
            setActiveTabKey(routeLocation.hash);
        } else setActiveTabKey('#list');
    });

    return (
        <AuthUserContext.Consumer>
            {(authUser) => (
                <AdminLayout authUser={authUser} pageTitle={restaurantDetails.title}>
                    <h2>Oferte</h2>
                    {isLoadingCompanyDetails ? (
                        <Skeleton active></Skeleton>
                    ) : companyDetails.message ? (
                        <Onboarding />
                    ) : isLoading ? (
                        <Skeleton active></Skeleton>
                    ) : entryFound === true ? (
                        <>
                            <RestaurantOffers restaurantId={restaurantId} />
                        </>
                    ) : entryFound === false ? (
                        <Onboarding step={2} />
                    ) : (
                        <Skeleton active />
                    )}
                </AdminLayout>
            )}
        </AuthUserContext.Consumer>
    );
}
const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(RestaurantOffersHome);
